import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Icon from '@material-ui/core/Icon'
const styles = theme => ({
  root: {
    flexGrow: 1
  },
  gridContainer: {
    minHeight: 240
  },
  backButton: {
    marginRight: theme.spacing.unit
  },
  instructions: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit
  },
  progress: {
    margin: `0 ${theme.spacing.unit * 2}px`
  },
  paperIcon: {
    borderRadius: '50%',
    width: 50,
    height: 50
  },
  leftIcon: {
    marginRight: theme.spacing.unit
  },
  icon: {
    fontSize: '50px'
  }
})

export default withStyles(styles)(
  class ConfirmEmailStepComponent extends React.Component {
    static propTypes = {
      classes: PropTypes.object,
      step: PropTypes.object.isRequired,
      auth: PropTypes.object.isRequired,
      sendEmail: PropTypes.func.isRequired,
      checkEmailVerification: PropTypes.func.isRequired,
      goToNext: PropTypes.func.isRequired,
      completed: PropTypes.func.isRequired
    }
    state = {
      sendEmailDisabled: false
    }
    timer = null
    handleSendConfirmationEmail = e => {
      this.props.sendEmail(false)
      this.setState({ sendEmailDisabled: true })
    }
    handleNextStep() {
      setTimeout(() => {
        this.props.goToNext()
      }, 1000)
    }
    componentWillUnmount() {
      clearInterval(this.timer)
      this.timer = null
    }
    componentWillReceiveProps(nextProps) {
      const { auth, step } = this.props
      if (
        auth &&
        nextProps.auth &&
        auth.emailVerified !== nextProps.auth.emailVerified &&
        !step.isCompleted
      ) {
        this.props.completed(true)
      }
      if (nextProps.step.isCompleted) {
        this.handleNextStep()
      }
    }
    componentDidMount() {
      const { auth } = this.props
      if (auth && !auth.emailVerified) {
        this.timer = setInterval(() => {
          this.props.checkEmailVerification()
          if (this.props.auth.emailVerified) {
            clearInterval(this.timer)
            this.timer = null
          }
        }, 5000)
      }
    }
    renderProgress() {
      const { classes, auth } = this.props
      return (
        <Grid container alignItems="center" direction="column" justify="center">
          <Grid item xs={12}>
            <CircularProgress
              className={classes.progress}
              color="secondary"
              size={50}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="headline" align="center" gutterBottom>
              En attente de validation de votre email...
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subheading" align="center" gutterBottom>
              Vérifiez votre boîte de réception ({auth.email})
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="caption" align="center" gutterBottom>
              Si vous n'avez pas reçu l'email de validation de votre compte :
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Button
              onClick={this.handleSendConfirmationEmail}
              disabled={this.state.sendEmailDisabled}
              size="small">
              <Icon className={classes.leftIcon}>send</Icon>
              Renvoyer l'email
            </Button>
          </Grid>
        </Grid>
      )
    }
    renderSuccessStep() {
      const { classes } = this.props
      return (
        <Grid container alignItems="center" direction="column" justify="center">
          <Grid item xs={12}>
            <Paper className={classes.paperIcon} elevation={4}>
              <Icon color="primary" className={classes.icon}>
                check
              </Icon>
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="headline">Email Validé !</Typography>
          </Grid>
        </Grid>
      )
    }
    render() {
      const { auth, classes } = this.props
      return (
        <Grid
          container
          alignItems="center"
          direction="column"
          justify="center"
          className={classes.root}>
          <Grid item xs={11}>
            <Grid
              container
              className={classes.gridContainer}
              alignItems="center"
              direction="row"
              justify="center">
              <Grid item xs={12}>
                {auth.emailVerified
                  ? this.renderSuccessStep()
                  : this.renderProgress()}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )
      // return
    }
  }
)



// WEBPACK FOOTER //
// ./src/routes/Boarding/components/ConfirmEmailStepComponent.js